module.exports = __webpack_public_path__ + "img/ic-account.07b45bd.svg";